import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import "@/sass/style.sass";
import { i18n } from "@/i18n/config";
import "@/services/api.service";
import { VMoney } from "v-money";
import {
  ZSelect,
  ZTextField,
  ZDatePicker,
  ZDataTable,
  ZFab,
  ZListItem,
  ZCard,
  ZTag,
  ZAutocomplete,
  ZAppBar,
  ZSnackbar,
  ZAvatar,
  ZUpload,
  ZFileInput,
  ZBooleanCol,
  ZTextArea,
  setupTheme,
  ZToggle,
  ZCheckbox,
  ZLoginField,
  ZDialog,
  ZAlert,
  ZLink,
  ZWizard,
  ZWizardBlock,
  ZButtonGroup,
  ZDarkModeToggle,
  ZTabs,
  ZBadgeNumber,
  ZUserMenu,
  ZBreadcrumb,
  ZSegmentedButton,
  ZPopup,
  ZPlainButton,
  ZSplitButton,
  ZSearchBar,
  ZRadio,
  ZRadioGroup,
  ZTutorialDialog,
  ZBasicButton,
  ZDateRangePicker,
  ZExpansionPanel,
} from "@zelando/vuelando";
import { defaultLightTheme, defaultDarkTheme } from "./helpers/themes";
import ThemeModule from "./store/modules/theme.module";
import { getModule } from "vuex-module-decorators";
const themeModule = getModule(ThemeModule, store);

Vue.config.productionTip = false;
Vue.component("z-select", ZSelect);
Vue.component("z-text-field", ZTextField);
Vue.component("z-date-picker", ZDatePicker);
Vue.component("z-date-range-picker", ZDateRangePicker);
Vue.component("z-data-table", ZDataTable);
Vue.component("z-list-item", ZListItem);
Vue.component("z-tag", ZTag);
Vue.component("z-fab", ZFab);
Vue.component("z-autocomplete", ZAutocomplete);
Vue.component("z-app-bar", ZAppBar);
Vue.component("z-snackbar", ZSnackbar);
Vue.component("z-avatar", ZAvatar);
Vue.component("z-upload", ZUpload);
Vue.component("z-file-input", ZFileInput);
Vue.component("z-boolean-col", ZBooleanCol);
Vue.component("z-textarea", ZTextArea);
Vue.component("z-toggle", ZToggle);
Vue.component("z-login-field", ZLoginField);
Vue.component("z-dialog", ZDialog);
Vue.component("z-alert", ZAlert);
Vue.component("z-wizard", ZWizard);
Vue.component("z-link", ZLink);
Vue.component("z-wizard-block", ZWizardBlock);
Vue.component("z-card", ZCard);
Vue.component("z-button-group", ZButtonGroup);
Vue.component("z-checkbox", ZCheckbox);
Vue.component("z-dark-mode-toggle", ZDarkModeToggle);
Vue.component("z-badge-number", ZBadgeNumber);
Vue.component("z-user-menu", ZUserMenu);
Vue.component("z-tabs", ZTabs);
Vue.component("z-breadcrumb", ZBreadcrumb);
Vue.component("z-segmented-button", ZSegmentedButton);
Vue.component("z-popup", ZPopup);
Vue.component("z-plain-button", ZPlainButton);
Vue.component("z-split-button", ZSplitButton);
Vue.component("z-search-bar", ZSearchBar);
Vue.component("z-radio", ZRadio);
Vue.component("z-radio-group", ZRadioGroup);
Vue.component("z-tutorial-dialog", ZTutorialDialog);
Vue.component("z-basic-button", ZBasicButton);
Vue.component("z-expansion-panel", ZExpansionPanel);
Vue.directive("money", VMoney);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
  created() {
    setupTheme(
      themeModule.dark ? defaultDarkTheme : defaultLightTheme,
      themeModule.dark
    );
  },
}).$mount("#app");
